import { useState } from "react";
import { SearchFilterBar } from "./searchFilter/SearchFilterBar";
import { SearchResultsList } from "./searchFilter/SearchResultsList";
import { CategoryGrid } from "./allCategories/CategoryGrid";
import { PopularCategories } from "./hotAndTrending/PopularCategories";
import { CategoryPreview } from "./allCategories/CategoryPreview";
import { TrustSection } from "./TrustSection";
import { CTASection } from "./CTASection";
import { useCategories } from "../../hooks/useCategories";

interface SearchResult {
  category: any;
  subCategory: any;
}

const CategoryMainPage = () => {
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [filters, setFilters] = useState({
    mode: "all",
    categoryType: "all",
    specialization: "all",
  });

  // Search state
  const [searchResults, setSearchResults] = useState<SearchResult[]>([]);
  const [isSearching, setIsSearching] = useState(false);

  // API
  const { categories, loading, error } = useCategories();

  const handleSearchResults = (results: SearchResult[], searching: boolean) => {
    setSearchResults(results);
    setIsSearching(searching);
  };

  const handleClearSearch = () => {
    setSearchQuery("");
    setFilters({
      mode: "all",
      categoryType: "all",
      specialization: "all",
    });
    setIsSearching(false);
    setSearchResults([]);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* 🔍 Search + Filters */}
      <SearchFilterBar
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        filters={filters}
        setFilters={setFilters}
        categories={categories || []}
        onSearchResults={handleSearchResults}
      />

      {/* 📋 Search Results - Only show when actively searching */}
      {isSearching ? (
        <SearchResultsList
          results={searchResults}
          isSearching={isSearching}
          searchQuery={searchQuery}
          onClearSearch={handleClearSearch}
        />
      ) : (
        /* 📦 Main Content - Only show when NOT searching */
        <>
          <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            {/* 🔥 Popular Categories */}
            <PopularCategories onSelectCategory={setSelectedCategory} />

            {/* 📂 Category Grid */}
            <CategoryGrid
              searchQuery={searchQuery}
              filters={filters}
              onSelectCategory={setSelectedCategory}
            />

            {/* 🔍 Category Preview Modal */}
            {selectedCategory && (
              <CategoryPreview
                categoryId={selectedCategory}
                onClose={() => setSelectedCategory(null)}
              />
            )}

            {/* ⚠️ Optional Error Message (non-blocking) */}
            {error && !loading && (
              <div className="mt-8 text-center text-sm text-gray-500 bg-gray-50 rounded-lg py-4 px-6">
                <p>Having trouble loading some categories. Showing available content.</p>
              </div>
            )}
          </main>

          {/* 🤝 Trust + CTA Sections */}
          <TrustSection />
          <CTASection />
        </>
      )}
    </div>
  );
};

export default CategoryMainPage;